// extracted by mini-css-extract-plugin
module.exports = {"root":"FeatureItem_root__3OVbk","content":"FeatureItem_content__35Mq4","icon":"FeatureItem_icon__3jsTH"};